import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-ink-border bg-ink-soft px-4 py-14" data-id="element-98">
      <div className="mx-auto max-w-3xl text-center" data-id="element-99">
        <p className="font-display text-xl uppercase tracking-wide text-gold" data-id="element-100">
          🧠 Le protocole clinique en 4 étapes™
        </p>
        <p className="mt-3 text-sm font-semibold text-white/75" data-id="element-101">
          Le système de planification n°1 pour les professionnels en cabinet
          libéral.
        </p>
        <p className="mt-4 text-sm text-white/55" data-id="element-102">
          Parce que la pratique clinique professionnelle ne devrait pas vous
          coûter toutes vos soirées de la semaine.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/60" data-id="element-103">
          <a href="mailto:support@eurekalabs.store" className="transition-colors hover:text-gold" data-id="element-104">
            📧 support@eurekalabs.store
          </a>
          <span data-id="element-105">📲 @eurekalabs</span>
          <span data-id="element-106">🌐 www.eurekalabs.store</span>
        </div>

        <p className="mt-8 text-xs text-white/35" data-id="element-107">
          © EUREKA LABS™ 2026 — Tous droits réservés.
        </p>
      </div>
    </footer>;
}